import { sentryService } from '@/services/telemetry/sentry';
import { errorMessage } from './track-telemetry';

export default function tryParsingJson(
  data: unknown,
  context?: string
): unknown {
  if (data == null || data === '') {
    return null;
  }
  const text = typeof data === 'string' ? data : String(data);
  try {
    return JSON.parse(text);
  } catch (e) {
    const message = errorMessage(e);
    console.warn('[JSON] Parse failed:', message);
    sentryService.addBreadcrumb(
      'json',
      `JSON parse failed${context ? ` (${context})` : ''}`,
      {
        error: message,
        data_type: typeof data,
        data_length: text.length,
        data_snippet: text.slice(0, 120),
        context: context ?? 'unknown',
      },
      'warning'
    );
    return null;
  }
}
